





















































































import { Component, Mixins } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import { DocumentSelectorMixin } from "./mixins";

@Component({
  components: {
    InfiniteLoading,
  },
})
export default class DocumentSelectorCardStyle extends Mixins(DocumentSelectorMixin) {
  get unpublishedStyle(): any {
    return {
      color: this.unpublishedColor,
    };
  }
}
